import { render, staticRenderFns } from "./IconErrorOutline.vue?vue&type=template&id=584fa130"
import script from "./IconErrorOutline.vue?vue&type=script&lang=js"
export * from "./IconErrorOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports